import { Box, Link } from '@mui/material';
import SmavaLogo from 'lib/smava/Logo';

interface LogoProps {
  logoLink?: string;
}

const Logo = ({ logoLink }: LogoProps) => {
  const logoPart = (
    <Box minWidth={138}>
      <SmavaLogo />
    </Box>
  );

  if (logoLink) {
    return <Link href={logoLink}>{logoPart}</Link>;
  }

  return logoPart;
};

export { Logo };
